<template>
    <div class="feedback">
        <router-link :to="{name: 'user', params: {id: feedback.author_id}}" class="feedback-avatar" :style="{backgroundImage: 'url('+ feedback.author.avatar +')'}"></router-link>
        <div class="feedback-right">
            <div class="feedback-header">
                <div class="feedback-header-left">
                    <h2 class="feedback-title">{{ feedback.author.firstname }} {{ feedback.author.lastname }}</h2>
                </div>
                <div class="feedback-header-right">
                    <p class="feedback-date">{{ $moment(feedback.date).locale('ru').fromNow() }}</p>
                </div>

            </div>
            <div class="feedback-body">
                <div class="feedback-content" v-html="feedback.content"></div>
            </div>
            <div class="feedback-footer">
                <div class="feedback-panel">
                    <div class="feedback-button" 
                        :class="{ active: hasLike(feedback), show: feedback.likes.length > 0 }" 
                        @click="likeHandler(feedback)"
                    >
                        <!-- <font-awesome-icon icon="smile" /> -->
                        <font-awesome-icon icon="heart" />
                        <p class="feedback-button__number">{{ feedback.likes.length > 0 ? feedback.likes.length : '' }}</p>
                    </div>
                    <div class="feedback-button" @click="reply = feedback">
                        <font-awesome-icon icon="reply" />
                    </div>
                    <div class="feedback-button" v-if="itsYour(feedback)" @click="$emit('setSettings', { feedback })">
                        <font-awesome-icon icon="ellipsis-h" />
                    </div>
                </div>
            </div>
            <p class="feedback-show" v-if="feedback.childs && feedback.childs.length > 0" @click="comments = !comments">{{comments ? 'Скрыть' : 'Показать'}} коментарии ({{feedback.childs.length}})</p>
            <div class="feedback-comments" v-if="feedback.childs && comments">
                <div class="feedback" v-for="(comment, index) in feedback.childs" :key="index">
                    <router-link :to="{name: 'user', params: {id: comment.author_id}}" class="feedback-avatar" :style="{backgroundImage: 'url('+ comment.author.avatar +')'}"></router-link>
                    <div class="feedback-right">
                        <div class="feedback-header">
                            <div class="feedback-header-left">
                                <h2 class="feedback-title">{{ comment.author.firstname }} {{ comment.author.lastname }}</h2>
                                <p class="feedback-to" v-if="comment.reply">@{{ comment.reply.author.nickname }}</p>
                            </div>
                            <div class="feedback-header-right">
                                <p class="feedback-date">{{ $moment(comment.date).locale('ru').fromNow() }}</p>
                            </div>

                        </div>
                        <div class="feedback-body">
                            <div class="feedback-content" v-html="comment.content"></div>
                        </div>
                        <div class="feedback-footer">
                            <div class="feedback-panel">
                                <div class="feedback-button"
                                    :class="{ active: hasLike(comment), show: comment.likes.length > 0 }" 
                                    @click="likeHandler(comment)"
                                >
                                    <font-awesome-icon icon="heart" />
                                </div>
                                <div class="feedback-button" @click="reply = comment">
                                    <font-awesome-icon icon="reply" />
                                </div>
                                <div class="feedback-button" v-if="itsYour(comment)" @click="$emit('setSettings', { feedback: comment })">
                                    <font-awesome-icon icon="ellipsis-h" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pin-adder" v-if="reply">
                    <div class="pin-adder-wrap">

                        <router-link 
                            :to="{name: 'user', params: {id: feedback.author_id}}" 
                            class="pin-adder__avatar" 
                            :style="{backgroundImage: 'url(' + getUserAvatar +')'}">
                        </router-link>
                        <input type="text" 
                            class="pin-input" 
                            :class="'pin-input-' + feedback.id" 
                            v-model="com_message" 
                            :placeholder="reply ? `Ответ пользователю ${reply.author.nickname}:` : 'Добавить комментарий'"  
                            @keydown.enter="inputHandler">
                        <div class="pin-adder-panel__item" @click="smiles = !smiles" >
                            <img src="@/assets/images/icons/smile.svg" width="24px"/>
                            <div class="pin-emoji" v-show="smiles" @click.stop>
                                <VEmojiPicker
                                    :emojiSize="24"
                                    :emojisByRow="6"
                                    :continuousList="true"
                                    @select="addSmile"/>
                            </div>
                        </div>
                        <div class="pin-adder-panel__item" @click="sendComment(feedback)">
                            <img src="@/assets/images/icons/plane.svg">
                        </div>
                    </div>
                </div>
        </div>
    </div>
</template>
<script>
import { VEmojiPicker } from 'v-emoji-picker';

export default {
    name: 'Feedback',
    data () {
        return {
            comments: false,
            reply: false,
            com_message: '',
            smiles: false,
        }
    },
    props: {
        feedback: {
            type: Object,
            required: true
        }
    },
    components: {
        VEmojiPicker
    },
    computed: {
        getUser() {
            return this.$store.getters.getAuthUser
        },
        getUserAvatar() {
            return this.getUser ? this.getUser.avatar : null
        },
        getEvent() {
            let event = this.$store.getters.getActiveEvent;
            return event 
                ? {
                    id: event.id,
                    hash: event.hash,
                    author_id: event.author_id,
                    title: event.title,
                } : null
        },
        getPlace() {
            let place = this.$store.getters.getActivePlace;
            return place 
                ? {
                    id: place.id,
                    hash: place.hash,
                    author_id: place.author_id,
                    title: place.title,
                } : null
        }
    },
    methods: {
        inputHandler(e) {
            if (e.keyCode === 13 && !e.shiftKey) {
                e.preventDefault();
                this.sendComment();
            }
        },
        escapeLinks(message) {
            const regexp = new RegExp(/([^"=]{2}|^)((https?|ftp):\/\/\S+[^\s.,> )\];'"!?])/);
            const subst = '$1<a href="$2" target="_blank">$2</a>'; 
            return message.replace(regexp, subst);
        },
        getContent() {
            let result = this.pin.content.replace(/\n/g, '<br>');
            let has_media = this.pin.media && this.pin.media.length > 0;
            if (has_media) {
                result = this.content ? result : this.cutString(result, 100)
            } 
            return this.escapeLinks(result);
        },
        likeHandler(feedback) {
            if (this.hasLike(feedback)) {
                let finded = feedback.likes.find(like => like.author_id === this.getUser.id);
                feedback.likes.splice(this.feedback.likes.indexOf(finded))
                feedback.event = this.getEvent;
                feedback.place = this.getPlace;
                feedback.event_id 
                    ? this.$store.dispatch('deleteEventCommentLike', feedback)
                    : this.$store.dispatch('deletePlaceCommentLike', feedback);
            } else {
                feedback.likes.push({ id: 0, comment_id: feedback.id, author_id: this.getUser.id, event_id: feedback.event_id })
                feedback.event_id 
                    ? this.$store.dispatch('sendEventCommentLike', feedback)
                    : this.$store.dispatch('sendPlaceCommentLike', feedback);
            }
        },
        itsYour(feedback) {
            return this.getUser && this.getUser.id == feedback.author_id
        },
        addSmile(smile) {
            this.com_message += smile.data
        },
        hasLike(feedback) {
            return feedback.likes.find(user => user.author_id === this.getUser.id)
        },
        async sendComment() {
            if (this.getUser) {
                
                let comment = {
                    event: this.getEvent,
                    place: this.getPlace,
                    event_id: this.feedback.event_id,
                    place_id: this.feedback.place_id,
                    reply: this.reply ? this.reply.id : null,
                    reply_author_id: this.reply && this.reply.author ? this.reply.author.id : null,
                    parent: this.feedback.id,
                    author_id: this.getUser.id,
                    content: this.com_message,
                }
                // TODO: перевести на this.$axios
                let created = this.feedback.event_id 
                    ? await this.$store.dispatch('sendEventComment', comment)
                    : await this.$store.dispatch('sendPlaceComment', comment);
                this.feedback.childs 
                    ? this.feedback.childs.push(created) 
                    : this.feedback.childs = [created];
                this.com_message = null
            } else {
                this.$router.push('/login')
                this.$store.dispatch('addNotification', {message: 'Чтобы выполнить это действие, войдите со своим аккаунтом. 😉'})
            }
        },
        openComments(val) {
            val ? this.comments = true : ''
        },
    },
    watch: {
        reply(val){ this.openComments(val)}
    }

}
</script>
<style lang="stylus" scoped>
.feedback
    width 100%
    margin 14px 0
    display flex
    &:hover
        .feedback-button
            opacity 1

    &-comments
        position relative
        +to-width(1023px)
            margin-left -45px
            .feedback-avatar
                min-width 30px
                width 30px
                height 30px
    &-avatar
        min-width 40px
        width 40px
        height 40px
        border-radius 50%
        background #333
        margin-right 14px
        background-size cover
        background-position center
        +to-width(360px)
            display none
    
    &-right
        padding-top 1px
        width 100%

    &-header
        display flex
        justify-content space-between
        align-items flex-end
        padding-bottom 5px
        width 100%

        &-left
            display flex
            align-items flex-end
        
    &-body
        width 100%

    &-title
        font-size 14px
        font-weight 600
        +to-width(800px)
            font-size 13px
    
    &-to
        color #53cbb5
        font-weight 500
        font-size 14px
        font-weight 600
        margin-left 10px
        +to-width(800px)
            font-size 10px
        &:before
            content 'to: '
            color #ececec

    &-content
        line-height 22px
        font-size 15px
        margin 2px 0

    &-panel
        display flex
        margin-top 5px
    
    &-button
        font-size 12px
        padding 4px
        color #b1b1b1
        background-color #f8f8f8
        border-radius 4px
        margin-right 4px
        transition 0.3s all
        cursor pointer
        display flex
        align-items center
        opacity 0.3
        transition 0.3s all

        &.active
            svg
                color #ff3246

        p
            margin-left 4px

        &:hover
            color #aaa
    
    &-show
        margin-top 8px
        font-size 11px
        color #8a8a9c
        cursor pointer

    .pin
        &-emoji
            position absolute
            bottom 38px
            right 0px
            background-color white
        &-input
            box-shadow none
            border none
            font-size 14px
            width 100%
        &-adder
            margin-top 10px
            margin-bottom 10px
            left 0
            right 0
            &__avatar
                min-width 30px
                width 30px
                height 30px
                border-radius 50%
                margin-right 15px
                background-size cover
            
            &-wrap
                display flex
                align-items center

            &-reply
                font-weight 500
                padding-left 45px

            &-panel
                &__item
                    position relative
                    padding 5px
                    margin-left 5px
                    img
                        transition 0.3s all
                        cursor pointer
                    &:hover
                        img
                            opacity 0.7
</style>